import React from 'react';

// Services & Helpers
import InstructorService from 'services/InstructorService';
import SubAgencyService from 'services/SubAgencyService';
import BootboxHelper from 'helpers/BootboxHelper';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import InstructorList from 'components/common/InstructorList';
import SearchBox from 'components/common/SearchBox';

//-------------------------------------------------------------------------------------------------------------------

class Instructors extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { subAgency } = this.props;
        const instructors = await InstructorService.list({ subAgencyID: subAgency.id });
        this.setState({
            instructors,
            isLoading: false
        });
    }

    addNewInstructor(type) {
        const { subAgency } = this.props;
        this.props.history.replace(`/instructor/new?type=${type}&subAgencyID=${subAgency.id}`);
    }

    async addInstructor(id) {
        if (this.state.isBusy) return;
        const { subAgency } = this.props;
        this.setState({ isLoading: true });
        const { success } = await SubAgencyService.addInstructor(subAgency.id, id, false);
        if (!success) {
            const confirm = await BootboxHelper.confirm('This instructor already belongs to another sub-agency. Adding them to this sub-agency will remove them from their current one. Continue?');
            if (confirm) {
                await SubAgencyService.addInstructor(subAgency.id, id, true);
            }
        }
        this.setState({ mode: null });
        this.load();
    }

    async removeInstructor(id) {
        if (this.state.isBusy) return;
        const { subAgency } = this.props;
        this.setState({ isLoading: true });
        await SubAgencyService.removeInstructor(subAgency.id, id);
        this.setState({ mode: null });
        this.load();
    }

    render() {
        const { isLoading, instructors, mode } = this.state;
        if (isLoading) {
            return (<Loader fullPage />);
        }

        return (<>

            <div className="sub-agency-instructors-control mb-3">
                {!!mode &&
                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ mode: null })}>
                        <span className="fa fa-chevron-left" />{' '}
                        Cancel
                    </button>
                }

                {!mode && <>
                    <button type="button" className="btn btn-secondary" onClick={() => this.addNewInstructor('Approved')}>
                        <span className="fa fa-plus" />{' '}
                        Add new approved instructor...
                    </button>

                    <button type="button" className="btn btn-secondary" onClick={() => this.addNewInstructor('Candidate')}>
                        <span className="fa fa-plus" />{' '}
                        Add new candidate...
                    </button>

                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ mode: 'add' })}>
                        <span className="fa fa-plus" />{' '}
                        Add existing instructor...
                    </button>

                    {instructors.length > 0 &&
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ mode: 'remove' })}>
                            <span className="fa fa-times" />{' '}
                            Remove instructor...
                        </button>
                    }
                </>}

                {mode == 'add' &&
                    <SearchBox
                        types={['Instructor']}
                        ignoreIDs={instructors.map(i => `instructor-${i.id}`)}
                        onSelect={item => {
                            const id = item.id.split('-')[1];
                            this.addInstructor(id);
                        }}
                    />
                }

                {mode == 'remove' && 
                    <div className="alert alert-warning">
                        Select an instructor to remove them from this sub-agency...
                    </div>
                }
            </div>

            {instructors.length == 0 &&
                <div className="empty-text">
                    No instructors have been added to this sub-agency yet
                </div>
            }

            <InstructorList
                instructors={instructors}
                onClick={async (instructor, e) => {
                    if (mode == 'remove') {
                        e.preventDefault();
                        e.stopPropagation();
                        const confirm = await BootboxHelper.confirm('Remove <b>' + TextHelpers.formatInstructorName(instructor) + '</b> from this sub-agency?');
                        if (confirm) {
                            this.removeInstructor(instructor.id);
                        }
                    }
                }}
            />
        </>);
    }

}

export default Instructors;